import React from 'react';
import PropTypes from 'prop-types';
import { toArray } from 'lodash';
import format from 'string-template';
import { connect } from 'react-redux';
import { format as reduxFormat } from 'redux-form-validators';

import { PASSWORD_MAX_LENGTH, PASSWORD_MIN_LENGTH, PASSWORD_REGEX } from '../../constants/form';

import InputFieldComponent from './InputFieldComponent';

class PasswordInputFieldComponent extends React.Component {
    validateMandatory = () => [
        reduxFormat({
            with: PASSWORD_REGEX,
            msg: format(
                this.props.i18nForm.PASSWORD_INVALID,
                PASSWORD_MIN_LENGTH,
                PASSWORD_MAX_LENGTH
            ),
            allowBlank: !this.props.isRequired
        }),
        ...toArray(this.props.validate)
    ];

    render() {
        return (
            <InputFieldComponent
                {...this.props}
                type="password"
                validate={
                    this.props.noDefaultValidation
                        ? toArray(this.props.validate)
                        : this.validateMandatory()
                }
            />
        );
    }
}

PasswordInputFieldComponent.propTypes = {
    isRequired: PropTypes.bool,
    noDefaultValidation: PropTypes.bool,
    validate: PropTypes.oneOfType([PropTypes.array, PropTypes.func])
};

const mapStateToProps = state => {
    return {
        i18nForm: state.i18n.feature.form
    };
};

export default connect(mapStateToProps)(PasswordInputFieldComponent);



// WEBPACK FOOTER //
// ./src/components/form/PasswordInputFieldComponent.js